export const environment = {
    production: false,
    titlePagePrefix: "[TEST] ",
    titlePagePostfix: " | Черноголовка",
    apiConfig: {
        apiUrl: "https://apim-power-bi-api-test.azure-api.net/power-bi-api",
    }
};